import React from "react";
import {
    SideFilterHeaderStyled,
    StyledFilterHeaderInnerWrapper,
} from "@/components/discovery/FilterModule/comps/AsideFilter/styled";
import {
    colors2,
    List
} from "oolib";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";
import {
    getValidBreakdownFields,
} from "../../InsightMatrix/utils/getValidFieldsForQuantViz";

export const BreakdownModule = ({ 
  options, 
  value, 
  onChange 
}) => (
  <>
    <SideFilterHeaderStyled
      style={{ position: "sticky", top: 0 }}
    >
      <StyledFilterHeaderInnerWrapper>
        <ButtonGhost
          onClick={() => onChange(null, undefined)}
          icon={"XCircle"}
          iconSize={"S"}
          iconColor={colors2.grey80}
          style={{
            color: colors2.grey80,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "start",
            paddingLeft: "20px",
            borderRadius: "0px",
          }}
        >
          {"Clear Breakdown"}
        </ButtonGhost>
      </StyledFilterHeaderInnerWrapper>
    </SideFilterHeaderStyled>
    <List
      options={options}
      value={value}
      onChange={onChange}
      disableShadow
    />
  </>
);